import { AnyAction } from 'redux';

// Config
import { ROUTER_LOCATION_CHANGE } from '@constants/actionConstants';

export const INITIAL_STATE = {
  location: {
    pathname: '/',
    search: 'RemsTest',
    hash: '',
    key: '',
  },
};

export default function locationReducer(state = INITIAL_STATE, action: AnyAction) {
  if (action.type === ROUTER_LOCATION_CHANGE) {
    return {
      location: action.payload.location,
    };
  }
  return state;
}
